export default __webpack_public_path__ + "static/media/card-m-service@3x.5617e4b4.png";